import { EProgramTypes } from '@ucheba/utils/types/program'

export const ProgramTypeChilds = {
  [EProgramTypes.higher]: [EProgramTypes.higherBachelor, EProgramTypes.higherSpeciality],
  [EProgramTypes.vocational]: [EProgramTypes.vocationalSpo, EProgramTypes.vocationalNpo],
  [EProgramTypes.course]: [
    EProgramTypes.course1,
    EProgramTypes.course2,
    EProgramTypes.course3,
  ],
}
